import { LinkStyled } from '@gr-monorepo/common/ui';
import React from 'react';
import { useClickStreamContext } from './ClickStream';
import { Link } from 'react-router-dom';

export const UnauthPlateText = () => {
  const { logPageEvent } = useClickStreamContext();
  return (
    <>
      <LinkStyled
        onClick={() => {
          logPageEvent({
            eventType: 'unauth_fake_plate_click_registrate',
            eventInfo: 'Неавторизованная зона фейковая плашка: клик по кнопке регистрация',
          });
        }}
        href={'https://upr-dostup.uchi.ru/'}
        data-qa-id="registerButton"
      >
        Пройдите регистрацию
      </LinkStyled>{' '}
      или{' '}
      <LinkStyled
        onClick={() => {
          logPageEvent({
            eventType: 'unauth_fake_plate_click_entrance',
            eventInfo: 'Неавторизованная зона фейковая плашка: клик по кнопке вход',
          });
          window.scrollTo(0, 0);
        }}
        as={Link}
        to={'/login'}
        data-qa-id="loginButton"
      >
        войдите
      </LinkStyled>{' '}
      в личный кабинет
      <br /> со своими логином и паролем, чтобы увидеть данные
    </>
  );
};
